module.exports = "<h1>{{headings}}</h1>\r\n<aside data-sidebar></aside\r\n><div data-ui-view='content' class=\"full\">";